import { ulid } from "ulid";
export function newReceiptId(): string { return ulid(); }
